import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const FALLBACK_IMG =
  "https://images.unsplash.com/photo-1532560460156-99a8b937ee8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHx3b21hbiUyMHNtaWxpbmclMjBvdXRkb29ycyUyMHN1bnNldHxlbnwwfHx8fDE3ODI4Mzk4NDR8MA&ixlib=rb-4.1.0&q=85";

const resolveImg = (url) => {
  if (!url) return FALLBACK_IMG;
  return url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
};

export const FounderNote = () => {
  const [c, setC] = useState({
    founder_heading: "A Note From Juliet",
    founder_name: "Juliet",
    founder_title: "Founder, KIS Living",
    founder_note:
      "KIS Living was created to help make life feel simpler, more inspired, and more enjoyable. Through KIS Living Vacations, we curate travel ideas and experiences that help you spend less time searching and more time enjoying the journey.",
    founder_image: "",
  });

  useEffect(() => {
    axios.get(`${API}/site-content`).then(({ data }) => setC((p) => ({ ...p, ...data }))).catch(() => {});
  }, []);

  return (
    <section data-testid="founder-section" className="py-20 md:py-32 bg-sand">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
          <div className="relative">
            <div className="overflow-hidden rounded-3xl">
              <img
                src={resolveImg(c.founder_image)}
                alt={`${c.founder_name}, founder of KIS Living`}
                className="w-full h-[480px] object-cover"
              />
            </div>
            <div className="hidden md:block absolute -bottom-6 -right-6 bg-terracotta text-white rounded-2xl px-7 py-5 shadow-lg">
              <p className="font-serif text-xl font-semibold">{c.founder_name}</p>
              <p className="text-sm text-white/85">{c.founder_title}</p>
            </div>
          </div>

          <div>
            <p className="uppercase text-sm tracking-[0.2em] font-semibold text-terracotta mb-4">
              From the founder
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-ink mb-6">
              {c.founder_heading}
            </h2>
            <p className="text-base sm:text-lg leading-relaxed text-ink-soft">{c.founder_note}</p>
            <p className="mt-6 font-serif text-3xl text-ink/30">{c.founder_name}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
